import React, { Component } from 'react';
import { connect } from 'react-redux';
import Multi from '../../components/Multi';
import Whitebox from '../../components/WhiteBox';
import BorderButton from '../../components/BorderButton';
import { FileInput } from '../import-audience/file-input';
import Papa from 'papaparse';
import axios from 'axios';
import Alert from 'react-s-alert';
import { Preloader } from '../../components/Chart/index';
import Promise from 'bluebird';
import UploadModal from './upload-modal';
import SessionService from '../../lib/services/SessionService';
import Amplify from 'aws-amplify';
import Big from 'big.js';
import config from '../../config';
import { aws_config } from '../../aws_config';
import { Auth, Storage } from 'aws-amplify';

// like java partition
function partition(array, n) {
  return array.length ? [array.splice(0, n)].concat(partition(array, n)) : [];
}

function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// default rows partition x request
const MAX_ROW_PARTITION = 40;

// Max concurrent HTTP Requests
const MAX_CONCURRENT_REQUESTS = 4;

class ImportAudienceFormBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      file: null,
      audienceExampleUpload:
        'audience_name,branded,alternative_id,description\nAudience test csv 1,1,a1,description 1\nAudience test csv 2,1,a2,descr 2\nAudience test csv 3,1,,\nAudience test csv 4,0,,description long description\n...',
      licenseExampleUpload:
        'audienceId,dmp,dmpProductId,cpmCost,currency,cookieDuration\nAUD0001,ddp,AR_MARKETPLACE,2500000,USD,30\nAUD0002,ddp,INVITE_ADVERTISER,1000000,USD,30\n...',
      errorMessage: '',
      audiencesJson: [],
      lastFile: null,
      fileInputId: new Date().getTime(),
      errors: [],
      success: [],
      operation: 'create',

      uploadStatus: {},
      uploadSuccess: false,
      toggleUpload: false,
      displayUploadModal: false,
    };
  }

  fileSelected(file) {
    console.log('fileSelected', file);
    this.setState(
      {
        file: file,
        errors: [],
        success: [],
        errorMessage: '',
        audiencesJson: [],
      },
      () => {
        console.log('pre select file ', file);
        console.log('papa pre parse ' + new Date());

        if (file.size > this.props.maxSizeBytes) {
          this.setState({
            errorMessage:
              'Maximum upload size is ' + this.props.maxSizeBytesStr,
          });
          return;
        }

        // parse CSV file on the client
        Papa.parse(file, {
          //worker: true,
          delimiter: ',',
          dynamicTyping: true,
          skipEmptyLines: true,
          header: true,
          quoteChar: '"',
          escapeChar: '"',
          transformHeader: function(value) {
            try {
              return value.trim();
            } catch (err) {
              return value;
            }
          },
          transform: function(value) {
            try {
              return value.trim();
            } catch (err) {
              return value;
            }
          },

          complete: (results) => {
            console.log('papa', results);
            console.log('papa parsed ' + new Date());
            if (
              results.errors.length > 0 &&
              results.errors[0].code != 'TooFewFields'
            ) {
              this.setState({
                errorMessage:
                  'Bad file format at row ' +
                  results.errors[0].row +
                  ': ' +
                  results.errors[0].message,
              });
              return;
            }

            if (
              results.data.length > 0 &&
              results.data.length > 1 + this.props.maxSizeRows
            ) {
              this.setState({
                errorMessage:
                  'Too many lines in file! The maximum supported row count is ' +
                  this.props.maxSizeRows,
              });
              return;
            }

            console.log('results.data[0] ', results.data[0]);
            console.log(
              'results.data[0].audience_name ',
              results.data[0]['audience_name']
            );

            // bad format
            if (
              this.props.type === 'audience' &&
              results.data &&
              results.data[0] &&
              results.data[0]['audience_name'] === undefined
            ) {
              this.setState({ errorMessage: 'Bad file format!' });
              return;
            }
            // bad format
            if (
              this.state.operation == 'create' &&
              this.props.type === 'license' &&
              results.data &&
              results.data[0] &&
              results.data[0]['audienceId'] === undefined
            ) {
              this.setState({ errorMessage: 'Bad file format!' });
              return;
            } else if (
              this.state.operation == 'update' &&
              this.props.type === 'license' &&
              results.data &&
              results.data[0] &&
              results.data[0]['licenseId'] === undefined
            ) {
              this.setState({ errorMessage: 'Bad file format!' });
              return;
            }

            this.setState({ audiencesJson: results.data });
          },
          error: (error, file) => {
            console.error('papa', error, file);
            this.setState({ errorMessage: 'Bad file format: ' + error });
            return;
          },
        });
      }
    );
  }

  // for bulk license upload the file on s3 to process it ona queue
  upload() {
    this.setState({ saving: true, displayUploadModal: true }, () => {
      this.uploadAudiencesToS3(this.state.file);
    });
  }

  uploadAudiencesToS3(file) {
    let self = this;

    let partnerId = '';

    let partnerLogged = SessionService.getPartnerLogged();

    // use masquerading partner id or the logged partner id
    if (partnerLogged != null) {
      partnerId = partnerLogged.partnerId;
    }

    const folder = `partner=${partnerId}/bulk-license`;
    const start = Date.now();
    let lastStep = new Big(0);

    let s3KeyPrefixUploaded = '';
    this.setState({ displayUploadModal: true }, () => {
      // amplify s3 upload

      // always use US for bulks
      aws_config.Storage.AWSS3.region = config.awsRegion;
      aws_config.Storage.AWSS3.bucket = config.audienceBucket;
      Amplify.configure(aws_config);

      Storage.put(`${folder}/${file.name}`, file, {
        // here you can set a custom prefix
        customPrefix: {
          private: 'poolid=',
        },
        partSize: 5 * 1024 * 1024,
        queueSize: 4,
        contentType: file.type,
        progressCallback(evt) {
          console.log('progressCallback ', evt);
          s3KeyPrefixUploaded = evt.key;

          const progress = new Big(evt.loaded).div(evt.total);
          const step = progress.times(100).round(0, 0);

          const now = Date.now();
          if (now > start && step.gt(lastStep)) {
            lastStep = step;
            const elapsed = new Big(now - start);
            const total = elapsed.div(progress);
            const remaining = total.minus(elapsed);

            // set progress state
            self.setState({
              uploadStatus: {
                uploading: true,
                progress: step.toFixed(0),
                eta: remaining
                  .div(1000)
                  .round(0, 0)
                  .toFixed(0),
                elapsed: elapsed
                  .div(1000)
                  .round(0, 0)
                  .toFixed(0),
              },
            });
          }
        },
      })
        .then((data) => {
          console.log('calling upload notification', data);

          // upload complete
          self.setState({
            uploadStatus: {
              uploading: false,
              checked: true,
              valid: true,
            },
            saving: false,
          });

          //
          // then send upload notification
          let fileurl =
            's3://' +
            aws_config.Storage.AWSS3.bucket +
            '/' +
            decodeURIComponent(s3KeyPrefixUploaded);
          let notificationData = {
            bucket: aws_config.Storage.AWSS3.bucket,
            prefix: decodeURIComponent(s3KeyPrefixUploaded),
          };
          console.log('notification data ', notificationData);

          // return this notificationData
          self.setState({ uploadNotificationData: notificationData });
        })
        .catch((err) => {
          console.log(err);

          // upload complete with errors
          self.setState({
            uploadStatus: {
              uploading: false,
              checked: true,
              valid: false,
              uploadError: err,
            },
            saving: false,
          });
        });
    });
  }

  onUploadModalConfirm() {
    this.setState({ displayUploadModal: false, saving: false }, () => {
      //this.props.save(this.state)

      // call bulk license notification with s3 path
      console.log(
        'bulk license upload confirm',
        this.state.uploadNotificationData
      );

      let method = 'POST';
      if (this.state.operation == 'update') {
        method = 'PATCH';
      }

      axios
        .request({
          method: method,
          url: '/license/bulk',
          data: this.state.uploadNotificationData,
        })
        .then((response) => {
          console.log('response.body ', response);

          Alert.success(
            'Bulk License queued. Please check out the Event page after some time to see the results of this import.'
          );

          // then redirect to licenses page
          window.location.href = '/licenses';
        });
    });
  }

  // end license bulk upload

  checkSaveButtonValid() {
    let ret = this.state.audiencesJson.length == 0;
    console.log('checkSaveButtonValid ret ' + ret);
    return ret;
  }

  onSave() {
    // force reset of the file input changing component key
    this.setState(
      { saving: true, errors: [], fileInputId: new Date().getTime() },
      () => {
        // returns a list of lists partitioned
        let partitionedArrays = partition(
          this.state.audiencesJson,
          this.props.rowsPartition || MAX_ROW_PARTITION
        );
        console.log(
          'on save ',
          this.state.audiencesJson,
          'partitionedArrays',
          partitionedArrays
        );
        partitionedArrays = partitionedArrays.map((list) => {
          if (this.props.type === 'audience') {
            return list.map((el) => {
              return {
                audienceName: el['audience_name'],
                branded: el['branded'],
                description: el['description'] || '',
                alternativeId: el['alternative_id'] || '',
              };
            });
          }
          return list;
        });
        console.log(
          'on save ',
          this.state.audiencesJson,
          'partitionedArr',
          partitionedArrays
        );

        if (partitionedArrays.length == 0) {
          Alert.error(
            'Audience Bulk Creation Error: no data loaded! Please refresh the page or select a new file to upload!'
          );
          this.setState({ saving: false });
          return;
        }

        // mark all axios requests for cancellation if one fails
        const source = axios.CancelToken.source();

        let success = [];
        let errors = [];
        let completed = 0;
        Promise.map(
          partitionedArrays,
          (el) => {
            let data = {};
            if (this.props.type === 'audience') {
              data = { audiences: el };
            } else {
              data = { licenses: el };
            }

            let method = 'POST';
            if (this.state.operation == 'update') {
              method = 'PATCH';
            }

            return axios
              .request({
                method: method,
                url:
                  this.props.type === 'audience'
                    ? '/audience/bulk'
                    : '/license/bulk',
                data: data,
                cancelToken: source.token,
              })
              .then((response) => {
                console.log('response.body ', response);
                if (response.data.body && response.data.body.errors) {
                  console.log(
                    'response.data.body.errors',
                    response.data.body.errors
                  );
                  errors = errors.concat(response.data.body.errors);
                }

                if (this.props.type === 'audience') {
                  success = success.concat(response.data.body.audiences);
                } else {
                  success = success.concat(response.data.body.licenses);
                }

                completed++;
                Alert.closeAll();
                Alert.success(
                  'Bulk progess: ' +
                    parseInt(
                      100 * parseFloat(completed / partitionedArrays.length)
                    ) +
                    ' %'
                );
              });
          },
          { concurrency: MAX_CONCURRENT_REQUESTS }
        )

          // all succeded
          .then((values) => {
            console.log('ALL FINISHED ', values, errors);
            if (errors && errors.length > 0) {
              this.setState({
                saving: false,
                errors: errors,
                success: success,
              });
              /*for(var i=0;i< errors.length; i++){
                            Alert.error("" + errors[i])
                        }*/
              Alert.closeAll();
              Alert.error(
                'Bulk Creation: There was some errors importing this file!'
              );
            } else {
              console.log('Bulk Creation Success save all promises', values);
              Alert.closeAll();
              Alert.success('Bulk Creation Completed Successfully!');
              this.props.goBack();
            }
          })
          // one in error
          .catch((err) => {
            /*if (axios.isCancel(err)) {
                        console.log('Audience Bulk Creation - Request canceled')
                    }*/

            Alert.error('Audience Bulk Creation Error: ' + err);
            this.setState({ saving: false });
            return;
          });
      }
    );
    return;
  }

  componentDidMount() {
    if (window.location.pathname === '/licenses/bulk-create') {
      this.setState({
        operation: 'create',
        licenseExampleUpload:
          'audienceId,dmp,dmpProductId,dmpClientId,cpmCost,currency,cookieDuration\nAUD0001,ddp,AR_MARKETPLACE,,2500000,USD,30\nAUD0002,ddp,INVITE_ADVERTISER,123,1000000,USD,30\n...',
      });
    }
  }

  onLicenseOperationChange(op) {
    if ('create' === op) {
      this.setState({
        operation: 'create',
        licenseExampleUpload:
          'audienceId,dmp,dmpProductId,dmpClientId,cpmCost,currency,cookieDuration\nAUD0001,ddp,AR_MARKETPLACE,,2500000,USD,30\nAUD0002,ddp,INVITE_ADVERTISER,123,1000000,USD,30\n...',
      });
    } else {
      this.setState({
        operation: 'update',
        licenseExampleUpload:
          'licenseId,cpmCost,currency,cookieDuration,status\nLIC0001,2500000,USD,30,\nLIC0002,,,300,\nLIC0003,,,,inactive\n...',
      });
    }
  }

  render() {
    return (
      <Multi>
        <UploadModal
          uploadStatus={this.state.uploadStatus}
          display={this.state.displayUploadModal}
          onConfirm={() => this.onUploadModalConfirm()}
        />

        <div className='row justify-content-center'>
          <div className='col-10'>
            <Whitebox>
              <div style={{ position: 'relative', paddingRight: 100 }}>
                <div className='row'>
                  <div className='col-3'>
                    <img
                      src='/img/audience/import-audience.png'
                      alt=''
                      style={{ maxWidth: '100%' }}
                    />
                  </div>

                  <div className='col-9'>
                    <h3 style={{ marginTop: 26 }}>
                      Bulk{' '}
                      {this.props.type === 'audience' ? 'Audience' : 'License'}{' '}
                      {this.state.operation == 'create' && (
                        <span>Creation</span>
                      )}
                      {this.state.operation == 'update' && <span>Update</span>}
                    </h3>
                    <p style={{ fontSize: 'smaller', color: '#797979' }}>
                      {capitalize(this.state.operation)} multiple{' '}
                      {this.props.type === 'audience'
                        ? 'Audiences'
                        : 'Licenses'}{' '}
                      using a CSV file
                    </p>
                    {this.props.type === 'license' && (
                      <>
                        <p>
                          <div className='row'>
                            <div className='col-12'>
                              <label>Operation</label>
                              <select
                                onChange={({ target }) => {
                                  this.onLicenseOperationChange(target.value);
                                }}
                                className='form-control'
                              >
                                <option value='create'>Create</option>
                              </select>
                            </div>
                          </div>
                        </p>
                        <p
                          className='alert alert-warning'
                          style={{
                            fontSize: 'smaller',
                            color: '#797979',
                          }}
                        >
                          To set price in Google Marketplace please mail us on
                          operations@audiencerate.com
                        </p>
                      </>
                    )}

                    <div className='row ' style={{ marginTop: '20px' }}>
                      <div className='col-md-12'>
                        <div className='card'>
                          <div className='card-body'>
                            <h5 className='card-title'>Upload a file</h5>
                            <p className='card-text'>
                              <div className='row'>
                                <div className='col-md-12'>
                                  <p
                                    style={{
                                      fontSize: 'smaller',
                                      color: 'rgb(121, 121, 121)',
                                    }}
                                  >
                                    File will be a plain .csv file with the
                                    first line with the header, separated by
                                    \n'. &#160;
                                    <b
                                      style={{
                                        color: 'black',
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      The Maximum upload size is{' '}
                                      {this.props.maxSizeBytesStr} and the
                                      maximum lines in file are{' '}
                                      {this.props.maxSizeRows}.
                                    </b>
                                  </p>

                                  {this.props.type === 'audience' && (
                                    <p
                                      style={{
                                        fontSize: 'smaller',
                                        color: 'rgb(121, 121, 121)',
                                      }}
                                    >
                                      <ul>
                                        <li>
                                          The text fields max length is 255
                                          characters.
                                        </li>
                                        <li>
                                          <b>Audience name</b> and{' '}
                                          <b>branded</b> are <u>mandatory</u>{' '}
                                          fields
                                        </li>
                                        <li>
                                          <u>Branded</u> can be 0 (false) and 1
                                          (true)
                                        </li>
                                        <li>
                                          Description and alternative_id are
                                          optional fields
                                        </li>
                                      </ul>
                                    </p>
                                  )}

                                  {this.props.type === 'license' && (
                                    <p
                                      style={{
                                        fontSize: 'smaller',
                                        color: 'rgb(121, 121, 121)',
                                      }}
                                    >
                                      {this.state.operation == 'create' && (
                                        <ul>
                                          <li>
                                            The text fields max length is{' '}
                                            <b>255 characters.</b>
                                          </li>
                                          <li>
                                            Audience id, dmp, dmpProductId,
                                            dmpClientId, cpmCost, currency,
                                            cookieDuration are <u>mandatory</u>{' '}
                                            fields.
                                          </li>
                                          <li>
                                            <p>For dmpProductId:</p>- For dmp{' '}
                                            <u>'ddp'</u> the field{' '}
                                            <u>dmpProductId</u> can have the
                                            values:
                                            <ul>
                                              <li>
                                                'INVITE_ADVERTISER' (DV360
                                                Advertiser)
                                              </li>
                                              <li>
                                                'INVITE_PARTNER' (DV360 Partner)
                                              </li>
                                              <li>
                                                'DFP_BY_GOOGLE' (DoubleClick for
                                                Publishers)
                                              </li>
                                              <li>
                                                'DFP_BY_GOOGLE_GLOBAL'
                                                (DoubleClick for Publishers
                                                Global)
                                              </li>
                                              <li>
                                                'AR_MARKETPLACE' (Google DV360
                                                Marketplace)
                                              </li>
                                            </ul>
                                            - For dmp <u>'adform'</u> you can
                                            set:
                                            <ul>
                                              <li>'ADFORM_MARKETPLACE'</li>
                                            </ul>
                                            - For Audiencerate Marketplace you
                                            will need to use <u>'ar'</u> as dmp
                                            and:
                                            <ul>
                                              <li>
                                                'AR_RESELLER' (Audience
                                                Marketplace)
                                              </li>
                                            </ul>
                                            <br />
                                          </li>
                                          <li>
                                            For licensing on <b>Adform</b> you
                                            will need to use <u>adform</u> as
                                            the dmp, and&#160;
                                            <u>ADFORM_MARKETPLACE</u> as the
                                            dmpProductId.
                                            <br />
                                            The <u>dmpClientId</u> can be a
                                            value like '1234' for selecting a
                                            specific agency code or you can use
                                            a placeholder to select a country or
                                            all countries supported by adform.
                                            &#160;
                                            <u>
                                              Please read how to do it on the
                                              documentation:{' '}
                                              <a
                                                target='_blank'
                                                href='/doc/license#adform'
                                              >
                                                Adform Licensing
                                              </a>
                                              .
                                            </u>
                                          </li>
                                          <li>
                                            <u>cpmCost</u> is in millions, for
                                            example 2.50$ will be: 2500000
                                          </li>
                                          <li>
                                            <u>currency</u> is a three letter
                                            currency symbol like USD, EUR, ...
                                          </li>
                                          <li>
                                            <u>cookieDuration</u> is in days, is
                                            the cookie TTL.
                                          </li>
                                        </ul>
                                      )}
                                      {this.state.operation == 'update' && (
                                        <ul>
                                          <li>
                                            License id is a <u>mandatory</u>{' '}
                                            field
                                          </li>
                                          <li>
                                            The other fields are optional and
                                            can be empty. If you don't want to
                                            update a specific field leave it
                                            empty.
                                            <br />
                                            <b>
                                              If you want to update "cpmCost"
                                              you will also need to specify the
                                              "currency" field.
                                            </b>
                                          </li>
                                          <li>
                                            <u>cpmCost</u> is in millions, for
                                            example 2.50$ will be: 2500000
                                          </li>
                                          <li>
                                            <u>currency</u> is a three letter
                                            currency symbol like USD, EUR, ...
                                          </li>
                                          <li>
                                            <u>cookieDuration</u> is in days
                                          </li>
                                          <li>
                                            <u>status</u> can be "active",
                                            "inactive"
                                          </li>
                                        </ul>
                                      )}
                                    </p>
                                  )}

                                  {this.props.type === 'audience' && (
                                    <p
                                      style={{
                                        fontSize: 'smaller',
                                        color: 'rgb(121, 121, 121)',
                                      }}
                                    >
                                      For Example:
                                      <pre
                                        style={{
                                          'background-color': 'transparent',
                                          color: 'black',
                                        }}
                                      >
                                        <div
                                          className='alert alert-secondary'
                                          role='alert'
                                        >
                                          <code
                                            style={{
                                              'background-color': 'transparent',
                                              color: 'black',
                                            }}
                                          >
                                            {this.state.audienceExampleUpload}
                                          </code>
                                        </div>
                                      </pre>
                                    </p>
                                  )}
                                  {this.props.type === 'license' && (
                                    <p
                                      style={{
                                        fontSize: 'smaller',
                                        color: 'rgb(121, 121, 121)',
                                      }}
                                    >
                                      For Example:
                                      <pre
                                        style={{
                                          'background-color': 'transparent',
                                          color: 'black',
                                        }}
                                      >
                                        <div
                                          className='alert alert-secondary'
                                          role='alert'
                                        >
                                          <code
                                            style={{
                                              'background-color': 'transparent',
                                              color: 'black',
                                            }}
                                          >
                                            {this.state.licenseExampleUpload}
                                          </code>
                                        </div>
                                      </pre>
                                    </p>
                                  )}
                                </div>
                              </div>

                              <div className='row'>
                                <div className='col-md-12'>
                                  <p style={{ marginTop: 0 }}>CSV File</p>
                                  <div className='import-license csv-upload'>
                                    {/* force reload components using key  */}
                                    <FileInput
                                      key={this.state.fileInputId}
                                      fileSelected={(file) =>
                                        this.fileSelected(file)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                className='row'
                                style={{ marginTop: '15px' }}
                              >
                                <div className='col-12'>
                                  {this.state.errorMessage != '' && (
                                    <b style={{ color: 'red' }}>
                                      {this.state.errorMessage}
                                    </b>
                                  )}
                                </div>
                              </div>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {this.state.errors && this.state.errors.length > 0 && (
                      <div
                        className='row'
                        style={{
                          marginTop: '20px',
                          maxHeight: '500px',
                          overflow: 'auto',
                        }}
                      >
                        <div className='col'>
                          <h3>Bulk Response:</h3>
                          <p
                            style={{
                              fontSize: 'smaller',
                              color: 'rgb(121, 121, 121)',
                            }}
                          >
                            There were <b>{this.state.success.length}</b> rows
                            successfully imported and{' '}
                            <u>
                              <b>{this.state.errors.length}</b> rows with errors
                            </u>
                            . Please fix those errors before trying to upload it
                            again:
                          </p>
                          <div className='alert alert-warning' role='alert'>
                            <ul>
                              {this.state.errors.map((el) => {
                                return <li>{el}</li>;
                              })}
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                    {this.state.saving && <Preloader transparent />}

                    <div className='new-segment-based-audience new-segment-based-audience--button-group'>
                      <BorderButton
                        className='grey'
                        label='Cancel'
                        onClick={() => this.props.goBack()}
                      />
                      <BorderButton
                        disabled={
                          this.checkSaveButtonValid() || this.state.saving
                        }
                        className='very-blue'
                        label='Upload'
                        onClick={() => {
                          console.log('on click save ', this.state);
                          if (this.props.type === 'license') {
                            this.upload();
                          } else {
                            this.onSave();
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Whitebox>
          </div>
        </div>
      </Multi>
    );
  }
}

export const ImportForm = connect(
  (state) => ({}),
  {
    //goBack: () => push(this.props.gobackurl)
  }
)(ImportAudienceFormBase);
